import React, { useState, useEffect } from 'react'

import { Panel, Table } from 'rsuite'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import pathname from '../../constants/pathname'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import { contractExtendPeriodCreate } from '../../redux/actions/contractExtendPeriod'

export default function ContractChangeExtendPeriodHistoryWidget({
  schema,
  header,
  enableAdd,
  isOverview,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  const history = useHistory()

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(schema)

  const projectId = sessionStorage.getItem('projectId')

  const handleCreateRequest = async () => {
    setIsLoading(true)
    try {
      let response = await contractExtendPeriodCreate(projectId)
      // console.log('response', response)
      if (response) {
        // sessionStorage.setItem('projectId', response.projectVersionId)
        sessionStorage.setItem('param', response.contractChangeId)
        history.push({
          pathname: `${pathname.proposal.contract.contractChangeExtendPeriodForm}`,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errors?.messag || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
  }

  const onView = (data) => {
    sessionStorage.setItem('param', data.id)
    history.push({
      pathname: `${pathname.proposal.contract.contractChangeExtendPeriodForm}`,
    })

    setIsLoading(false)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel
        shaded
        header={header || formSchema?.header || 'ประวัติการขอขยายระยะเวลา/กิจกรรมและงบประมาณ'}
        collapsible
        defaultExpanded
      >
        {enableAdd && formSchema?.newButton && (
          <SaveButton icon="plus" children={formSchema?.newButton} onClick={handleCreateRequest} />
        )}

        <Table
          headerHeight={70}
          autoHeight={!isOverview || (formSchema?.data || []).length <= 5}
          height={isOverview && (formSchema?.data || []).length > 5 ? 400 : undefined}
          wordWrap
          bordered
          data={formSchema?.data || []}
          style={{ marginBottom: 10 }}
        >
          <Column width={95} align="center">
            <HeaderCell>ครั้งที่</HeaderCell>
            <Cell dataKey="seq" />
          </Column>
          <Column width={150} minWidth={150} flexGrow={1} align="center">
            <HeaderCell>จากวันสิ้นสุด</HeaderCell>
            <Cell dataKey="oldDate" />
          </Column>
          <Column width={150} minWidth={150} flexGrow={1} align="center">
            <HeaderCell>ขยายเป็นวันที่</HeaderCell>
            <Cell dataKey="newdate" />
          </Column>

          {/* <Column width={120} align="center">
            <HeaderCell>
              แก้ไขระยะ
              <br />
              เวลาโครงการ
            </HeaderCell>
            <Cell dataKey="changPeriod" />
          </Column>
          <Column width={120} align="center">
            <HeaderCell>
              แก้ไขกิจกรรม
              <br />
              และงบประมาณ
            </HeaderCell>
            <Cell dataKey="changActivityBudget" />
          </Column>
          <Column width={120} align="center">
            <HeaderCell>แก้ไขงวดงาน</HeaderCell>
            <Cell dataKey="changBudgetPeriod" />
          </Column> */}
          <Column width={150} minWidth={150} flexGrow={1} align="center">
            <HeaderCell>วันที่ขอขยายเวลา</HeaderCell>
            <Cell dataKey="requestDate" />
          </Column>
          <Column width={150} minWidth={150} flexGrow={1} align="center">
            <HeaderCell>วันที่อนุมัติ</HeaderCell>
            <Cell dataKey="apppoveDate" />
          </Column>
          <Column width={300} minWidth={300} flexGrow={2} align="center">
            <HeaderCell>สถานะ</HeaderCell>
            <Cell dataKey="statusName" />
          </Column>

          <Column width={150} align="center" fixed="right">
            <HeaderCell></HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <ViewButton
                    onClick={() => {
                      onView(rowData)
                    }}
                  />
                )
              }}
            </Cell>
          </Column>
        </Table>
      </Panel>
    </>
  )
}
